module.exports = __webpack_public_path__ + "assets/img/btn-info-d6f9fd24.png";